export const CHAT_UPLOAD_MAX_IMAGE_FILE_BYTES = 5 * 1024 * 1024;
export const CHAT_UPLOAD_MAX_VIDEO_BYTES = 30 * 1024 * 1024;

const IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];
const VIDEO_MIME_TYPES = ['video/mp4', 'video/mpeg', 'video/quicktime'];
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
const VIDEO_EXTENSIONS = ['mp4', 'mpeg', 'mov'];

export function classifyChatUploadFile(file) {
  if (!file) return 'file';
  const typeFile = file.type || '';
  const ext = String(file.name || '').split('.').pop().toLowerCase();

  if (IMAGE_MIME_TYPES.includes(typeFile) || IMAGE_EXTENSIONS.includes(ext)) {
    return 'image';
  }
  if (VIDEO_MIME_TYPES.includes(typeFile) || VIDEO_EXTENSIONS.includes(ext)) {
    return 'video';
  }
  return 'file';
}

export function validateChatUploadFile(file) {
  if (!file) {
    return { ok: false, message: 'Tệp không hợp lệ.' };
  }

  if (!file.size || file.size <= 0) {
    return { ok: false, message: 'Ảnh từ clipboard không hợp lệ hoặc đã hết hạn — hãy chụp/chép lại.' };
  }

  const kind = classifyChatUploadFile(file);
  const maxBytes = kind === 'video' ? CHAT_UPLOAD_MAX_VIDEO_BYTES : CHAT_UPLOAD_MAX_IMAGE_FILE_BYTES;
  const maxMb = kind === 'video' ? 30 : 5;

  if (file.size > maxBytes) {
    const label = kind === 'video' ? 'Video' : 'Ảnh/tệp';
    return {
      ok: false,
      message: `${label} "${file.name}" vượt quá ${maxMb}MB.`,
    };
  }

  return { ok: true, kind };
}
